const select = document.querySelector('.country .custom__select');
const button = select.querySelector('.custom__select__button');

button.addEventListener('click', () => {
  const isOpen = select.classList.toggle('open');
  button.setAttribute('aria-expanded', isOpen);
});

document.addEventListener('click', e => {
  if (!select.contains(e.target)) {
    select.classList.remove('open');
    button.setAttribute('aria-expanded', 'false');
  }
});
